import script from "./TeamCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./TeamCard.vue?vue&type=script&setup=true&lang=ts"

import "./TeamCard.vue?vue&type=style&index=0&id=0b161cc0&lang=css"

const __exports__ = script;

export default __exports__